module.exports = __webpack_public_path__ + "static/img/banner-movimento-ods.da00735.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/banner-movimento-ods.jpg
// module id = /vAg
// module chunks = 15